import React, { useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FocusEventHandler } from "react";

type BasePasswordInputProp = {
  label: string;
  id: string;
  styleClass?: string;
  maxLength?: number;
  minLength?: number;
  value: string;
  name: string;
  disabled?: boolean;
  required?: boolean;
  change: any;
  hasError?: boolean | string | undefined;
  errorMsg?: string;
  bodyStyles?: string;
  blur?: FocusEventHandler<HTMLInputElement> | undefined;
  min?: number;
  max?: number;
  inputClass?: string;
};

const BasePassword: React.FC<BasePasswordInputProp> = ({
  label,
  id,
  name,
  styleClass = "",
  inputClass = "",
  maxLength,
  minLength,
  value,
  disabled = false,
  required = false,
  change,
  blur,
  hasError = false,
  errorMsg,
}) => {
  const [isPassword, setIsPassword] = useState(false);
  const togglePassword = () => {
    setIsPassword(!isPassword);
  };

  return (
    <div className="flex flex-col">
      <div
        className={`fieldset ${
          !value ? "bg-[#F9FAFC]" : "bg-white"
        } flex_between_centered border border-[#E5E9F2] dark:border-[#E5E9F2] dark:focus:border-[#A0A1B9] rounded-lg pb-2 pt-1 px-4 h-[56px] box-border relative overflow-x-hidden mt-2 ${styleClass} ${
          hasError && "border border-[#F85359] dark:border-[#F85359]"
        }`}
      >
        <div className="form-group flex flex-col-reverse flex-grow h-full flex-between">
          <input
            id={id}
            name={name}
            placeholder={label}
            type={isPassword ? "text" : "password"}
            maxLength={maxLength}
            minLength={minLength}
            className={`${inputClass} form-group__input font-medium text-[#2D2D31] ${
              !value ? "bg-[#F9FAFC]" : "bg-white"
            } cursor-text animate-p5s flex flex-grow outline-none
                        focus:outline-none no-default disabled:bg-gray-200 cursor-not-allowed`}
            defaultValue={value}
            disabled={disabled}
            autoComplete="off"
            onChange={change}
            onBlur={blur}
          />
          <label
            htmlFor={id}
            className="form-group__label pointer-events-none transform origin-left transition-all duration-100 ease-in-out text-sm opacity-50 cursor-text animate-p5s w-fit"
          >
            {label}
            <span className="text-red-600">{required ? " *" : ""}</span>
          </label>
          <div
            className="absolute right-0 flex top-[6px] items-center cursor-pointer p-2"
            onClick={togglePassword}
          >
            {isPassword ? (
              <AiFillEye className="text-[1.5rem]" />
            ) : (
              <AiFillEyeInvisible className="text-[1.5rem]" />
            )}
          </div>
        </div>
      </div>
      {hasError && (
        <p className="text-[#F85359] text-[12px] pt-1">{errorMsg}</p>
      )}
    </div>
  );
};

export default BasePassword;
